import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TTextDM from './TTextDM'
import TAttendanceMovementIntervalDM from './TAttendanceMovementIntervalDM'
import TAttendanceWorkTimeReportDM from './TAttendanceWorkTimeReportDM'
import TK2UserLookupDM from './TK2UserLookupDM'

export default class TAttendanceAuxiliaryIntervalDM extends Data {
	public static className = 'TAttendanceAuxiliaryIntervalDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'TimeStamp',
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	HoursCount?: number
	MovementDateTo?: Date
	MovementDateFrom?: Date
	BookId?: number
	WorkTimeReportItemRID?: number
	RightGroupId?: number
	TimeStamp?: string
	ChangedOn?: Date
	CreatedOn?: Date
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	RightGroupIdCalc?: number
	@Type(() => TTextDM)
	OriginTypeId?: TTextDM
	@Type(() => TAttendanceMovementIntervalDM)
	MovementSubTypeRID?: TAttendanceMovementIntervalDM
	@Type(() => TAttendanceWorkTimeReportDM)
	WorkTimeReportRID?: TAttendanceWorkTimeReportDM
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM
}